module.exports = __webpack_public_path__ + "static/media/Others.2dad4b36.jpg";